import React from 'react';
import { useAppContext } from '@prisjakt/ui-app-context';

import { IconVerfied } from '@prisjakt/ui/icon';
import { FontEmphasis } from '@prisjakt/ui/text';
import { CaptionText } from '@prisjakt/ui/text/variants';
import { Tooltip, TooltipPlacement } from 'src/components/tooltip-new';

import { DesktopOnly, IconWrapper, PriceInfoElement } from './styles';

export const RecommendedRetailerBadge: React.FC = () => {
  const { t } = useAppContext();

  return (
    <PriceInfoElement>
      <Tooltip
        placement={TooltipPlacement.TOP}
        title={t('store', 'brand.recommended-retailer')}
        renderOnMouseOver
      >
        <IconWrapper>
          <IconVerfied color="base300" />
        </IconWrapper>
      </Tooltip>
      <DesktopOnly>
        <CaptionText emphasis={FontEmphasis.MEDIUM}>
          {t('store', 'brand.recommended-retailer')}
        </CaptionText>
      </DesktopOnly>
    </PriceInfoElement>
  );
};
